import { isDefined } from "@clipboard-health/util-ts";
import { CardLoader } from "@src/app/ratings/CardLoader";
import { RatingCard, type RatingCardProps } from "@src/app/ratings/cards/RatingsCard";
import { TabRouterPath } from "@src/app/routing/constant/tabRoute";
import { logEvent } from "@src/appV2/lib/analytics";
import { useDefinedWorker } from "@src/appV2/Worker/useDefinedWorker";
import { useGetWorkerBadges } from "@src/appV2/WorkerBadges/api/useGetWorkerBadges";
import { useIsWorkerBadgesEnabled } from "@src/appV2/WorkerBadges/useIsWorkerBadgesEnabled";
import { USER_EVENTS } from "@src/constants";
import pluralize from "pluralize";
import { useHistory } from "react-router-dom";

export function WorkerBadgesCard() {
  const history = useHistory();
  const isWorkerBadgesEnabled = useIsWorkerBadgesEnabled();

  const { userId: workerId } = useDefinedWorker();

  const {
    isLoading,
    data: badgesResponse,
    isError,
  } = useGetWorkerBadges(workerId, {
    enabled: isWorkerBadgesEnabled,
  });

  const handleBadgesClicked = () => {
    if (workerId) {
      logEvent(USER_EVENTS.RATINGS_PAGE_VIEW_DETAILS_CLICKED, {
        workerId: workerId,
        section: "badges",
      });

      history.push(TabRouterPath.RATINGS_BADGES);
    }
  };

  if (!isWorkerBadgesEnabled || isError) {
    return null;
  }

  if (isLoading || !isDefined(badgesResponse)) {
    return <CardLoader />;
  }

  if (badgesResponse.data.length === 0) {
    return null;
  }

  const badgeCount = badgesResponse.data.length;

  const badgesCardProps: RatingCardProps = {
    title: "My Badges",
    description: `You have earned ${badgeCount} ${pluralize(
      "badge",
      badgeCount
    )}. Take a moment to view how much you've accomplished so far! Thank you for your hard work!`,
    buttonText: "See badges",
    buttonOnClick: handleBadgesClicked,
    scoreValue: badgeCount,
    scoreColor: "success",
    testId: "worker-badges",
  };

  return <RatingCard {...badgesCardProps} />;
}
